export default "__VITE_ASSET__DdM$H1OG__"